import { Card, CardContent, CardHeader, CardTitle } from "../../../../../components/ui/card";
import { Button } from "../../../../../components/ui/button";
import { OperationConfirmDialog } from "../../../../../components/ui/operation-confirm-dialog";
import { useState } from "react";
import { EntregoBaixaItem } from "../types";
import { BaixaStatCard } from "./baixa-stat-card";
import { DollarSign, FileText, Database } from "lucide-react";

interface EntregoBaixaItemCardProps {
  baixaItem: EntregoBaixaItem;
  selectedOps: string[];
  onStartDoc: (filterDate: string, listOps: string[]) => void;
  onSubmitDb: (filterDate: string, listOps: string[]) => void;
  isStartingDoc: boolean;
  isSubmittingDb: boolean;
}

export function EntregoBaixaItemCard({
  baixaItem,
  selectedOps,
  onStartDoc,
  onSubmitDb,
  isStartingDoc,
  isSubmittingDb,
}: EntregoBaixaItemCardProps) {
  const [openStartDoc, setOpenStartDoc] = useState(false);
  const [openSubmitDb, setOpenSubmitDb] = useState(false);

  const filterDate = baixaItem.data_romaneio.slice(0, 10);
  const isDatePassed = new Date() > new Date(baixaItem.data_vencimento);

  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(value / 100);
  };

  return (
    <Card>
      <CardHeader className="pb-3">
        <div className="flex items-center justify-between">
          <CardTitle className="text-lg">
            Data Romaneio: {filterDate}
          </CardTitle>
          <div className="flex gap-2">
            <Button
              size="sm"
              variant="outline"
              onClick={() => setOpenStartDoc(true)}
              disabled={isStartingDoc}
            >
              <FileText className="mr-2 h-4 w-4" />
              Criar CNAB
            </Button>
            <Button
              size="sm"
              onClick={() => setOpenSubmitDb(true)}
              disabled={!isDatePassed || isSubmittingDb}
            >
              <Database className="mr-2 h-4 w-4" />
              Realizar Baixa
            </Button>
          </div>
        </div>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <BaixaStatCard
            title="Valor de Face"
            value={formatCurrency(baixaItem.valor_face)}
            icon={<DollarSign className="h-6 w-6" />}
          />
          <BaixaStatCard
            title="Valor de Compra"
            value={formatCurrency(baixaItem.valor_compra)}
            icon={<DollarSign className="h-6 w-6" />}
          />
          <BaixaStatCard
            title="Deságio"
            value={formatCurrency(baixaItem.desagio)}
            icon={<DollarSign className="h-6 w-6" />}
          />
        </div>
      </CardContent>

      <OperationConfirmDialog
        open={openStartDoc}
        onOpenChange={setOpenStartDoc}
        onConfirm={() => onStartDoc(filterDate, selectedOps)}
        action="baixa"
        ops={selectedOps.join(", ")}
        date={filterDate}
        details={[{ label: "Etapa", value: "Criar CNAB de baixa" }]}
      />

      <OperationConfirmDialog
        open={openSubmitDb}
        onOpenChange={setOpenSubmitDb}
        onConfirm={() => onSubmitDb(filterDate, selectedOps)}
        action="baixa"
        ops={selectedOps.join(", ")}
        date={filterDate}
        details={[{ label: "Etapa", value: "Realizar baixa no banco de dados" }]}
      />
    </Card>
  );
}
